// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_headerContainer__tXKYN {
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 0.5rem;
  /* Previne animações/transições que causam "pulo" na tela */
  will-change: auto;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.styles_header__o7-Sn {
  align-items: center;
  color: #18316e;
  display: flex;
  font-size: 2rem;
  gap: 0.5rem;
  padding-left: 1rem;
  /* position: absolute; */
}

.styles_headerIcon__ncUzh .MuiSvgIcon-root {
  align-items: center;
  display: flex;
  font-size: 2rem;
}

.styles_headerTitle__gAc8y {
  color: #18316e;
  font-family: "Abhaya Libre";
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.2;
  padding-top: .15rem;
}

.styles_headerRight__T6XNE {
  align-items: flex-end;
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
}

.styles_headerEmpresas__fMteJ {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  min-width: 16rem;
}

.styles_viewContainer__RrDjc {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0;
}

.styles_selectView__j6F2n {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: nowrap;
}

.styles_iconView__cLzP\\+ {
  color: #18316e !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_iconView__cLzP\\+:hover {
  background-color: #bebebe !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  padding: 0.5rem !important;
}

.styles_iconViewActive__NofXP {
  background-color: #919191 !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

@media (max-width: 768px) {
  .styles_headerRight__T6XNE {
    justify-content: center;
  }

  .styles_headerEmpresas__fMteJ {
    flex-direction: column;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TableCardv2/Header/styles.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,2DAA2D;EAC3D,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".headerContainer {\n  align-items: flex-end;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-top: 0.5rem;\n  /* Previne animações/transições que causam \"pulo\" na tela */\n  will-change: auto;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n.header {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  font-size: 2rem;\n  gap: 0.5rem;\n  padding-left: 1rem;\n  /* position: absolute; */\n}\n\n.headerIcon :global(.MuiSvgIcon-root) {\n  align-items: center;\n  display: flex;\n  font-size: 2rem;\n}\n\n.headerTitle {\n  color: #18316e;\n  font-family: \"Abhaya Libre\";\n  font-size: 1.4rem;\n  font-weight: 600;\n  line-height: 1.2;\n  padding-top: .15rem;\n}\n\n.headerRight {\n  align-items: flex-end;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 1rem;\n}\n\n.headerEmpresas {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  min-width: 16rem;\n}\n\n.viewContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 0;\n}\n\n.selectView {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex-wrap: nowrap;\n}\n\n.iconView {\n  color: #18316e !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.iconView:hover {\n  background-color: #bebebe !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  padding: 0.5rem !important;\n}\n\n.iconViewActive {\n  background-color: #919191 !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n@media (max-width: 768px) {\n  .headerRight {\n    justify-content: center;\n  }\n\n  .headerEmpresas {\n    flex-direction: column;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `styles_headerContainer__tXKYN`,
	"header": `styles_header__o7-Sn`,
	"headerIcon": `styles_headerIcon__ncUzh`,
	"headerTitle": `styles_headerTitle__gAc8y`,
	"headerRight": `styles_headerRight__T6XNE`,
	"headerEmpresas": `styles_headerEmpresas__fMteJ`,
	"viewContainer": `styles_viewContainer__RrDjc`,
	"selectView": `styles_selectView__j6F2n`,
	"iconView": `styles_iconView__cLzP+`,
	"iconViewActive": `styles_iconViewActive__NofXP`
};
export default ___CSS_LOADER_EXPORT___;
